/**
 * CascadeAlerts.jsx - Cascade event alerts component
 * Displays detected cascade events during social simulations
 * Extracted from Analysis.jsx
 */
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Badge } from '../ui/badge';
import { AlertCircle } from 'lucide-react';
import { cn } from '../../lib/utils';

const CascadeAlerts = ({ cascades }) => {
  if (!cascades || cascades.length === 0) return null;
  
  return (
    <Card data-testid="cascade-alerts">
      <CardHeader className="pb-2">
        <div className="flex items-center gap-2">
          <AlertCircle className="w-5 h-5 text-warning" />
          <CardTitle className="text-sm font-medium">Cascade Events Detected</CardTitle>
          <Badge variant="outline" className="text-xs bg-warning-soft text-warning-soft-foreground border-warning-border">
            {cascades.length}
          </Badge>
        </div>
      </CardHeader>
      <CardContent>
        <div className="space-y-2.5">
          {cascades.map((c, i) => (
            <div key={i} className={cn(
              "flex items-center gap-3 p-2.5 rounded-lg border text-sm",
              c.direction === 'positive' ? 'bg-positive-soft border-positive-border' : 'bg-negative-soft border-negative-border'
            )}>
              <div className={cn(
                "w-8 h-8 rounded-full flex items-center justify-center text-white text-xs font-bold shrink-0",
                c.direction === 'positive' ? 'bg-positive' : 'bg-negative'
              )}>
                {c.direction === 'positive' ? '↑' : '↓'}
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-xs font-medium text-slate-800">
                  Round {c.round}: {c.size} agents shifted {c.direction}ly toward "{c.trigger_response}"
                </p>
                <p className="text-[11px] text-muted-foreground">
                  Average shift: {c.avg_shift}pp
                </p>
              </div>
              <Badge variant="outline" className="text-[10px] shrink-0">{c.size} agents</Badge>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
};

export default CascadeAlerts;
